import dayjs from 'dayjs';
import { DATE_FORMAT } from '../constants/dateConstants';

export const validateDateIsAfterToday = (value) => {
  const newDate = dayjs(value, DATE_FORMAT);

  if (!value || !newDate.isValid()) {
    return null;
  }

  if (newDate.isBefore(dayjs().startOf('day'))) {
    return null;
  }
  return value;
};
